// extracted by mini-css-extract-plugin
module.exports = {"root":"bz_b9"};